import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

interface AdminRouteProps {
  children: React.ReactNode;
}

/**
 * Admin route component that redirects to dashboard if user is not an admin.
 * Assumes user is already authenticated (use inside ProtectedRoute or authenticated layout).
 */
export default function AdminRoute({ children }: AdminRouteProps) {
  const { isAuthenticated, user } = useAuth();

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If not admin, redirect to dashboard
  if (user?.role !== "admin") {
    return <Navigate to="/analysis" replace />;
  }

  return <>{children}</>;
}
